import type { FaireProductEntity } from "../../entity_types/product";

export const p_pjychkd4bd: FaireProductEntity = {
  token: "p_pjychkd4bd",
  type: "product",
  name: "Pickleball Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/08742da5f13f28e0ac4cda9f2b1f3b250388fb1b16ae59b3f45facfbcfe69e5d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff5359f3aa37da5649aaafdf3651e3e6d7d3ba80a71e71dab6367dad0aa58730.jpeg",
    "https://cdn.faire.com/fastly/3f3b474e620ef583300d9473acc9bfdb3f4f2e8e5034e0b7906ebe877201c937.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:16.274Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
